import { render, staticRenderFns } from "./common-tupu.vue?vue&type=template&id=3d099862&scoped=true&"
import script from "./common-tupu.vue?vue&type=script&lang=ts&"
export * from "./common-tupu.vue?vue&type=script&lang=ts&"
import style0 from "./common-tupu.vue?vue&type=style&index=0&id=3d099862&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d099862",
  null
  
)

export default component.exports